'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loader = require('./components/Loader');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-loader/lib/index.js
// module id = 138
// module chunks = 1